// store/app.ts
import { create } from "zustand";

type AppState = {
  selectedDaysRange: number | null;
  isAudioRecording: boolean;
  isAudioProcessing: boolean;

  setSelectedDaysRange: (days: number | null) => void;
  setIsAudioRecording: (recording: boolean) => void;
  setIsAudioProcessing: (processing: boolean) => void;
};

export const useAppStore = create<AppState>((set) => ({
  selectedDaysRange: null,
  isAudioRecording: false,
  isAudioProcessing: false,

  setSelectedDaysRange: (days) => set({ selectedDaysRange: days }),
  setIsAudioRecording: (recording) => set({ isAudioRecording: recording }),
  setIsAudioProcessing: (processing) => set({ isAudioProcessing: processing }),
}));
